/** Status / tag editors: the dialog loads its content (and drag-and-drop) only when opened. */
import { Suspense, lazy } from 'react';
import { Dialog } from '@/components/ui/overlay';
import { useEditors } from './editor-store';

const EditorContent = lazy(() => import('./editors'));

export function EditorHost() {
  const { spec, set } = useEditors();
  return (
    <Dialog open={!!spec} onOpenChange={(o) => !o && set(null)}>
      <Suspense fallback={null}>{spec && <EditorContent spec={spec} />}</Suspense>
    </Dialog>
  );
}
